"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateScript = void 0;
const models_1 = require("app/models");
const models_2 = require("app/models");
const firestore_web_1 = require("comodel/firestore-web");
const function_client_1 = require("@/utils/function-client");
const copilotApi_1 = require("@/schemaComponents/modules/copilotApi");
function updateScript(_a) {
    return __awaiter(this, arguments, void 0, function* ({ projectId, segmentId, scriptId, data, }) {
        const scriptAccessor = (0, firestore_web_1.documentAccessor)(models_1.scriptDefinition, {
            projectId,
            segmentId,
            scriptId,
        }, true);
        const segmentAccessor = (0, firestore_web_1.documentAccessor)(models_2.segmentDefinition, {
            projectId,
            segmentId,
        }, true);
        // WORKAROUND: tags にemptyやundefinedが入るとエラーになるため、filterする
        // タグ側の実装を修正しだい下記は不要になる
        const { tags } = data, rest = __rest(data, ["tags"]);
        const filteredTags = tags === null || tags === void 0 ? void 0 : tags.filter(Boolean);
        const scriptData = Object.assign(Object.assign({}, rest), { tags: filteredTags });
        yield scriptAccessor.upsert(scriptData);
        yield (0, function_client_1.syncScriptSearchDocument)({
            projectId,
            segmentId,
            scriptId,
            endpoint: (0, copilotApi_1.getApiEndPoint)(),
        });
        yield segmentAccessor.upsert({
            updatedAt: Date.now(),
        });
    });
}
exports.updateScript = updateScript;
